import styled, { css, keyframes } from 'styled-components';
import { Link } from 'gatsby';

interface StyledMenuLinkProps {
  justify?: 'stretch' | 'center' | 'left' | 'right';
  $fadeIn?: boolean;
}

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const sharedHeaderMenuLinkStyles = css<StyledMenuLinkProps>`
  position: relative;
  text-decoration: none;
  font-size: 16px;
  line-height: 1.2;
  color: var(--header-text-color-theme);
  font-weight: 400;
  align-self: center;
  border-bottom: 1px solid transparent;
  transition: border-bottom 0.3s ease-in-out;
  margin: 5px 9px 6px;
  justify-self: ${({ justify }) => justify || 'stretch'};

  ${(props) =>
    !props.$fadeIn
      ? ''
      : css`
          animation: ${fadeIn} 0.5s ease;
        `}

  &::after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    transition: width 300ms ease-in-out;
    width: 0;
    height: 100%;
    border-bottom: 1px solid var(--header-text-color-theme);
  }

  &:hover {
    border-bottom-color: var(--header-text-color-theme);

    &::after {
      width: 100%;
    }
  }

  &.active {
    font-weight: 700;
    border-bottom-color: var(--header-text-color-theme);

    &:hover {
      border-bottom-color: var(--header-text-color-theme);
    }

    &::after {
      display: none;
    }
  }

  &:not(active):hover {
    border-bottom-color: transparent;

    &::after {
      width: 100%;
    }
  }
`;

// Only internal links, if external http is required, clone this to <a> tag
export const StyledMenuLink = styled(Link)<StyledMenuLinkProps>`
  ${sharedHeaderMenuLinkStyles}
`;

export const StyledMenuExpandableToggle = styled.div<StyledMenuLinkProps>`
  ${sharedHeaderMenuLinkStyles}
  align-self: center;
  display: inline-flex;
  cursor: pointer;
  gap: 2px;

  path {
    fill: var(--header-text-color-theme);
  }
`;
